import {GetServerSideProps} from "next";
import fetch from "node-fetch";
import {CrosswordDataType} from "@/types/crosswords";
import CrosswordView from "@/components/Crossword/CrosswordView/CrosswordView";
import FLSProvider, {FLSLoader, useFLS} from "@/utils/FLSProvider";
import CrosswordBuffer from "@/components/Crossword/CrosswordBuffer/CrosswordBuffer";
import CHGamesHead from "@/components/Layout/CHGamesHead/CHGamesHead";


export type CrosswordStateType = {
  crosswordId: string | null
  crosswordUserBoard: string[][]
  crosswordCheckedBoard: string[][]
  crosswordGameState: 'playing' | 'success'
  crosswordTimeElapsed: number
  crosswordFastestTime: number | null
  crosswordTimes: Record<string, {date: string, time: number, hasCheated: boolean}>
  crosswordHasCheated: boolean
}

export const crosswordDefaultState: CrosswordStateType = {
  crosswordId: null,
  crosswordUserBoard: [],
  crosswordCheckedBoard: [],
  crosswordGameState: 'playing',
  crosswordTimeElapsed: 0,
  crosswordFastestTime: null,
  crosswordTimes: {},
  crosswordHasCheated: false,
}

type Props = {
  crossword: CrosswordDataType
}

const CrosswordPage = ({crossword}: Props) => {

  return (
    <>
      <CHGamesHead
        title="Crossword"
        description="A weekly Magic: The Gathering-themed crossword puzzle by EDHREC."
        />
      <FLSProvider database="ch-games" collection="userDataCrossword" defaultState={crosswordDefaultState}>
        <FLSLoader>
          <CrosswordBuffer crossword={crossword}>
            <CrosswordView crossword={crossword}/>
          </CrosswordBuffer>
        </FLSLoader>
      </FLSProvider>
    </>
  )
}

export default CrosswordPage

export const useCrosswordState = <
  K extends keyof CrosswordStateType
>(
  key: K,
  fallback?: CrosswordStateType[K]
) => useFLS<CrosswordStateType, K>(key, fallback);

export const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
  const crossword = await fetch("https://getcurrentcrossword-hpca4snkqq-uc.a.run.app").then(res => res.json())

  return {
    props: {
      crossword,
    }
  }
}